var _require = require("../helper"),
    validHubspotTrackingId = _require.validHubspotTrackingId,
    getCookie = _require.getCookie;

exports.addHubspot = function (options) {
  return new Promise(function (resolve, reject) {
    if (window.gatsbyPluginGDPRCookiesHubspotAdded) return resolve(true);
    var head = document.body;
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "hs-script-loader";
    script.key = "gatsby-plugin-hubspot";
    script.async = true;
    script.defer = true;

    script.onload = function () {
      window.gatsbyPluginGDPRCookiesHubspotAdded = true;
      resolve(true);
    };

    script.src = "//js.hs-scripts.com/" + options.trackingId + ".js";
    head.appendChild(script);
  });
};

exports.initializeHubspot = function (options) {
  if (!window.gatsbyPluginGDPRCookiesHubspotInitialized && getCookie(options.cookieName) === "true" && validHubspotTrackingId(options)) {
    window.gatsbyPluginGDPRCookiesHubspotInitialized = true;
  }
};